import React from "react";
import styled from "styled-components";
import StatusItem from "@src/components/Item/StatusChangeItem";
import { StatusItemType as StatusItemType } from "@src/types/item.type";
import { transferToNative } from "@src/lib/WebAppBridge";
import Header from "@src/components/Header";
import { useGetSampleItems } from "@src/hooks/item/useSampleItems";

const SampleBidList = () => {
    const { data } = useGetSampleItems();

    const handleItemClick = (item: StatusItemType) => {
        transferToNative(JSON.stringify({ itemId: item.item_id, bidType: item.bid_type }), "openSampleBidDetail");
    };

    return (
        <Layout>
            <Header title="샘플 미리보기" />
            <ItemBox>
                {data?.map((item: StatusItemType) => (
                    <StatusItem key={item.item_id} {...item} onClick={() => handleItemClick(item)} />
                ))}
            </ItemBox>
        </Layout>
    );
};

export default SampleBidList;

const Layout = styled.div``;

const ItemBox = styled.div`
    height: calc(100vh - 56px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
        display: none;
    }
`;
